module.exports = __webpack_public_path__ + "media/images/riders/ADAM_BRAYTON-59eefef52b3ed793d5ed870f57d42338.png";